import LoadingModal from '@/js/components/organisms/modals/LoadingModal.vue';
import { mountModal } from './helper/dynamic-modal';

export const loading = <T>({ asyncFunc, text }: { asyncFunc?: () => Promise<T>; text?: string }) =>
  mountModal<T>({
    Component: LoadingModal,
    props: { loadingText: text },
    asyncFunc,
  });
